import type * as openapi from '@/helpers/api/types/openapiOverrides';

/**
 * Get base name by ID from the bases catalog
 */
export function getBaseName(
  baseId: number | null | undefined,
  bases: openapi.GetCatalogBases_200,
): string {
  if (!baseId) return '';

  const base = bases.find(
    (b: openapi.GetCatalogBases_200[number]) => b.number === baseId,
  );
  return base?.name || `Base ${baseId}`;
}
